export enum FanReportsLabel {
  All = 'All',
  Renews = 'Renews',
  NewSubscribers = 'New subscribers',
  UnSubs = 'Unsubs',
  ActiveFans = 'Active fans',
  TurnedOffAutoRenewOn = 'Turned auto-renew on',
  TurnedOffAutoRenewOff = 'Turned auto-renew off',
}

export const FanReportsColors = {
  [FanReportsLabel.All]: '#3467FF',
  [FanReportsLabel.ActiveFans]: '#3467FF',
  [FanReportsLabel.Renews]: '#2fc25b',
  [FanReportsLabel.TurnedOffAutoRenewOn]: '#2fc25b',
  [FanReportsLabel.NewSubscribers]: '#FF6868',
  [FanReportsLabel.UnSubs]: '#2fc25b',
  [FanReportsLabel.TurnedOffAutoRenewOff]: '#FF6868',
}

export type FanReportsColorKeys = keyof typeof FanReportsColors